export enum InvoiceStateEnum {
  Draft,
  Approved,
  Sent,
  Paid,
  Cancelled
}
